document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.maviva-product-section');
  if (!section) return;

  const radios = section.querySelectorAll('.js-variant-radio');
  const masterSelect = section.querySelector('.js-master-select');
  const priceCurrent = section.querySelector('.js-price-current');
  const priceOld = section.querySelector('.js-price-old');
  const addBtn = section.querySelector('.js-add-btn');
  const mainImage = section.querySelector('.js-main-image');
  const thumbBtns = section.querySelectorAll('.js-thumb-btn');

  // -- GESTIONE VARIANTI --
  radios.forEach(radio => {
    radio.addEventListener('change', () => {
      // 1. Aggiorna il testo della label
      const index = radio.getAttribute('data-index');
      const labelSpan = section.querySelector(`.js-selected-value-${index}`);
      if (labelSpan) labelSpan.textContent = radio.value;

      // 2. Trova la combinazione selezionata
      const selectedOptions = [];
      const checkedRadios = section.querySelectorAll('.js-variant-radio:checked');
      checkedRadios.forEach(r => selectedOptions.push(r.value));

      // 3. Trova l'option nel master select che corrisponde a questa combinazione
      const optionsStr = selectedOptions.join(' / ');
      let matchedOption = Array.from(masterSelect.options).find(opt => opt.text.includes(optionsStr));

      if (matchedOption) {
        masterSelect.value = matchedOption.value; // Aggiorna il form

        // Aggiorna URL senza ricaricare la pagina
        const url = new URL(window.location);
        url.searchParams.set('variant', matchedOption.value);
        window.history.replaceState({}, '', url);

        // Aggiorna Prezzi
        if (priceCurrent) priceCurrent.textContent = matchedOption.getAttribute('data-price');
        if (priceOld) {
          const comparePrice = matchedOption.getAttribute('data-compare-price');
          priceOld.textContent = comparePrice || '';
          priceOld.style.display = comparePrice ? 'inline' : 'none';
        }

        // Aggiorna Immagine se la variante ne ha una specifica
        const newImg = matchedOption.getAttribute('data-img');
        if (newImg && mainImage) {
          mainImage.style.opacity = '0';
          setTimeout(() => {
            mainImage.src = newImg;
            mainImage.style.opacity = '1';
          }, 200);
        }

        // Aggiorna Bottone Add to Cart
        if (matchedOption.disabled) {
          addBtn.disabled = true;
          addBtn.textContent = 'Esaurito';
        } else {
          addBtn.disabled = false;
          addBtn.textContent = 'Aggiungi al carrello';
        }
      } else {
        // Combinazione non esistente
        addBtn.disabled = true;
        addBtn.textContent = 'Non disponibile';
      }
    });
  });

  // -- GESTIONE GALLERIA IMMAGINI --
  thumbBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      thumbBtns.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      
      const newImgUrl = btn.getAttribute('data-img-url');
      if (mainImage && newImgUrl) {
        mainImage.style.opacity = '0';
        setTimeout(() => {
          mainImage.src = newImgUrl;
          mainImage.style.opacity = '1';
        }, 200);
      }
    });
  });

  // -- GESTIONE QUANTITÀ --
  const qtyInput = section.querySelector('.js-qty-input');
  const btnMinus = section.querySelector('.js-qty-minus');
  const btnPlus = section.querySelector('.js-qty-plus');

  if (qtyInput && btnMinus && btnPlus) {
    btnMinus.addEventListener('click', () => {
      let val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });

    btnPlus.addEventListener('click', () => {
      let val = parseInt(qtyInput.value) || 1;
      qtyInput.value = val + 1;
    });
  }
});